function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    if (event.target.classList.contains('single' )){
      [...this.querySelectorAll(".quantity__button")].map( x => x.disabled = true);
    }
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }


  }
}
customElements.define('quantity-input', QuantityInput);

const CART_UPSELL_FORM_SELECTOR = [
  '.upsell_cart form[data-add-to-cart-form]',
  '.upsell_cart form[data-add-to-cart-formtwo]',
  '.upsell_custom form[data-add-to-cart-form]',
].join(', ');

const CART_UPSELL_SECTIONS = [
  { id: 'cart-drawer', selector: '.drawer__inner' },
  { id: 'header', selector: '#cart-icon-bubble' },
];

const cartUpsellParser = new DOMParser();
const sectionsParam = CART_UPSELL_SECTIONS.map((section) => section.id).join(',');

const getUpsellVariantId = (form) => {
  const input = form.querySelector('input[name="id"]');
  return input ? String(input.value) : null;
};

const updateUpsellButtonDisplay = (form, inCart) => {
  const addButton = form.querySelector('#custom-cart-button');
  const addedButton = form.querySelector('#added-to-cart');

  if (!addButton || !addedButton) {
    return;
  }

  addButton.style.display = inCart ? 'none' : 'block';
  addedButton.style.display = inCart ? 'block' : 'none';
};

const refreshUpsellButtonStates = () => {
  const upsellForms = Array.from(document.querySelectorAll(CART_UPSELL_FORM_SELECTOR));
  if (!upsellForms.length) return;

  fetch('/cart.js')
    .then((response) => response.json())
    .then((cart) => {
      upsellForms.forEach((form) => {
        const variantId = getUpsellVariantId(form);
        if (!variantId) return;

        const productInCart = cart.items.some((item) => String(item.variant_id) === variantId);
        updateUpsellButtonDisplay(form, productInCart);
      });
    })
    .catch((error) => {
      console.error('Error refreshing upsell button states:', error);
    });
};

const renderUpsellSections = (sections = {}) => {
  CART_UPSELL_SECTIONS.forEach(({ id, selector }) => {
    const sectionHtml = sections[id];
    if (!sectionHtml) return;

    const fragment = cartUpsellParser.parseFromString(sectionHtml, 'text/html');
    const source = fragment.querySelector(selector);
    const target = document.querySelector(selector);

    if (!source || !target) {
      return;
    }

    target.innerHTML = source.innerHTML;

    if (id === 'cart-drawer') {
      const drawer = document.querySelector('.drawer');
      if (drawer) {
        drawer.classList.remove('is-empty');
      }
      attachCartUpsellListeners(target);
    }
  });
};

const handleCartUpsellSubmit = async (event) => {
  event.preventDefault();
  const form = event.target?.tagName === 'FORM' ? event.target : event.currentTarget;

  if (!form || form.dataset.upsellSubmitting === 'true') {
    return;
  }

  form.dataset.upsellSubmitting = 'true';

  const formData = new FormData(form);
  formData.append('sections', sectionsParam);
  formData.append('sections_url', window.location.pathname);

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { Accept: 'application/json' },
    });
    const data = await response.json();

    if (!response.ok) {
      throw data;
    }

    updateUpsellButtonDisplay(form, true);
    renderUpsellSections(data.sections);
    refreshUpsellButtonStates();
  } catch (error) {
    console.error('Error adding upsell product to cart:', error);
  } finally {
    delete form.dataset.upsellSubmitting;
  }
};

const attachCartUpsellListeners = (_root = document) => {
  // Submit is handled via document-level delegation below so that upsell
  // forms work when cart drawer content is replaced (first open, onCartUpdate, renderContents).
};

// Delegate submit so upsell forms work when cart drawer content is replaced
// (e.g. first open after cart update, or after renderContents from add-to-cart)
document.addEventListener('submit', (event) => {
  if (!event.target || typeof event.target.matches !== 'function') return;
  if (!event.target.matches(CART_UPSELL_FORM_SELECTOR)) return;
  event.preventDefault();
  handleCartUpsellSubmit(event);
});

document.addEventListener('DOMContentLoaded', () => {
  attachCartUpsellListeners();
  refreshUpsellButtonStates();
});

document.addEventListener('shopify:section:load', (event) => {
  attachCartUpsellListeners(event.target);
  refreshUpsellButtonStates();
});

document.addEventListener('click', (event) => {
  const removalButton = event.target.closest('.button--tertiary');
  if (!removalButton) return;

  setTimeout(() => {
    refreshUpsellButtonStates();
  }, 500);
});

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;

    if (poster.dataset.autoplay == 'true') {
      this.loadContent();
    }
    
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class ProductCarousel extends HTMLElement {
  constructor() {
    super();

    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = true;

    // this.currentPageElement = this.querySelector('.slider-counter--current');
    // this.pageTotalElement = this.querySelector('.slider-counter--total');

    this.sliderFirstItemNode = this.slider.querySelector('.slider__slide');
    this.currentPage = 1;

    if( this.querySelector('[data-slider-dots]') ){
      this.sliderControlWrapper = this.querySelector('[data-slider-dots]');
      this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
      this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    }else{
      this.sliderControlWrapper = this.querySelector('.slider-buttons');
      this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
      this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    }

    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    // if (this.currentPageElement && this.pageTotalElement) {
    //   this.currentPageElement.textContent = this.currentPage;
    //   this.pageTotalElement.textContent = this.totalPages;
    // }

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

}

customElements.define('product-carousel', ProductCarousel);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.progressBar = this.querySelector('.progress');
    this.progressBar = this.querySelector('.progress');
    if (!this.slider || !this.nextButton) return;
    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);
    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    // Update progress bar
    if( !this.progressBar ) return;

    let currentTotal = this.totalPages - 1;
    const progressBarWidth = ( this.currentPage / currentTotal ) * 100;
    this.progressBar.style = `--progress-width: ${progressBarWidth}%`;

  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}
customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateVariantInput();
      this.renderProductInfo();

      if (this.classList.contains('lp-product-section')) {
        const submitButton = document.querySelector('.product-form__submit');
        if (submitButton && submitButton.hasAttribute('href')) {
          submitButton.href = `/cart/add?id=${this.currentVariant.id}&quantity=1&return_to=/checkout`;
        }
        return;
      }

      this.updateURL();
      this.updateShareUrl();
    }

    // NEW: Update variant-specific content based on the "Kleur" option
    this.updateVariantContent();
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);

    const variantPriceElement = document.getElementById('variant-price');

    const twoVariantPriceElement = document.getElementById('two_original_price');
    const twoDiscountPriceElement = document.getElementById('two_discount_price');
    const twoSavePriceElement = document.getElementById('twoDiscountTag');

    const threeVariantPriceElement = document.getElementById('three_original_price');
    const threeDiscountPriceElement = document.getElementById('three_discount_price');
    const threeSavePriceElement = document.getElementById('discountTag');

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      if (twoVariantPriceElement || twoDiscountPriceElement || threeVariantPriceElement || threeDiscountPriceElement) {
        const variantPrice = (this.currentVariant.price / 100).toFixed(2);

        const twoVariantPrice = (variantPrice * 2).toFixed(2);
        const twoDiscountPrice = (twoVariantPrice - (twoVariantPrice * 0.10)).toFixed(2);

        const threeVariantPrice = (variantPrice * 3).toFixed(2);
        const threeDiscountPrice = (threeVariantPrice - (threeVariantPrice * 0.15)).toFixed(2);

        variantPriceElement.textContent = "€" + variantPrice.replace('.', ',');

        twoDiscountPriceElement.textContent = "€" + twoDiscountPrice.replace('.', ',');
        twoVariantPriceElement.textContent = "€" + twoVariantPrice.replace('.', ',');
        twoSavePriceElement.textContent = (twoVariantPrice - twoDiscountPrice).toFixed(2);

        threeDiscountPriceElement.textContent = "€" + threeDiscountPrice.replace('.', ',');
        threeVariantPriceElement.textContent = "€" + threeVariantPrice.replace('.', ',');
        threeSavePriceElement.textContent = (threeVariantPrice - threeDiscountPrice).toFixed(2);
      }
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(variant => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map(variantOption => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        // Prevent unnecessary UI changes if the selection has changed
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);
        const productComparePrice = document.querySelector('.custom-product-upsell-price .comparusa');
        const productDefPrice = document.querySelector('.custom-product-upsell-price .pricurda');

        if (productComparePrice) {
          productComparePrice.innerText = source.querySelector('.main-product-price-container').getAttribute('data-def-price');
        }
        if (productDefPrice) {
          productDefPrice.innerText = source.querySelector('.main-product-price-container').getAttribute('data-sale-price');
        }
        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);
        if (price) price.classList.remove('visibility-hidden');
        if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant
          }
        });
// 🔹 NEW: Update Klarna block on variant change
      const klarnaSource = html.querySelector('.acc-klarna-mention__right');
      const klarnaDestination = document.querySelector('.acc-klarna-mention__right');

      if (klarnaSource && klarnaDestination) {
        klarnaDestination.innerHTML = klarnaSource.innerHTML;
      }

      // Update sticky mobile section price
      const stickyPriceSource = html.getElementById(`price-${sectionId}`);
      const stickyPriceDestination = document.getElementById(`price-sticky-${this.dataset.section}`);
      if (stickyPriceSource && stickyPriceDestination) {
        stickyPriceDestination.innerHTML = stickyPriceSource.innerHTML;
      }

      // Update sticky mobile section Klarna
      const stickyKlarnaSource = html.querySelector('.acc-klarna-mention__right');
      const stickyKlarnaDestination = document.querySelector('.product-sticky-mobile .acc-klarna-mention__right');
      if (stickyKlarnaSource && stickyKlarnaDestination) {
        stickyKlarnaDestination.innerHTML = stickyKlarnaSource.innerHTML;
      }

      // Update sticky mobile section button
      const stickyButtonSource = html.getElementById(`ProductSubmitButton-${sectionId}`);
      const stickyButtonDestination = document.getElementById(`ProductSubmitButton-${this.dataset.section}-sticky`);
      if (stickyButtonSource && stickyButtonDestination) {
        stickyButtonDestination.disabled = stickyButtonSource.hasAttribute('disabled');
        const stickyButtonText = stickyButtonDestination.querySelector('.button-text');
        const stickyButtonSourceText = stickyButtonSource.querySelector('.button-text');
        if (stickyButtonText && stickyButtonSourceText) {
          stickyButtonText.textContent = stickyButtonSourceText.textContent;
        } else if (stickyButtonText && stickyButtonSource.innerText) {
          stickyButtonText.textContent = stickyButtonSource.innerText.trim();
        }
      }

      // Update sticky mobile section variant ID input
      const stickyForm = document.querySelector(`#product-form-${this.dataset.section}-sticky`);
      if (stickyForm && this.currentVariant) {
        const stickyVariantInput = stickyForm.querySelector('.product-variant-id');
        if (stickyVariantInput) {
          stickyVariantInput.value = this.currentVariant.id;
        }
      }

        // ——— NEW: Update message section ———
      const destinationMessage = document.getElementById(
        `message-${this.dataset.section}`
      );
      const sourceMessage = html.getElementById(
        `message-${sectionId}`
      );
      if (sourceMessage && destinationMessage) {
        destinationMessage.innerHTML = sourceMessage.innerHTML;
        destinationMessage.classList.toggle(
          'hidden',
          sourceMessage.innerHTML.trim() === ''
        );
      }


        // ——— NEW: CUSTOM LINE PROPERTY BACK ORDER DATE ———
const destinationBackorder = document.getElementById(`backorder-${this.dataset.section}`);
const sourceBackorder = html.getElementById(`backorder-${sectionId}`);
if (sourceBackorder && destinationBackorder) {
  destinationBackorder.innerHTML = sourceBackorder.innerHTML;
  destinationBackorder.classList.toggle('hidden', sourceBackorder.innerHTML.trim() === '');
}

// ——— NEW: CUSTOM LINE PROPERTY PREORDER DATE ———
const destinationPreorder = document.getElementById(`preorder-${this.dataset.section}`); // ← bez 'p'
const sourcePreorder = html.getElementById(`preorder-${sectionId}`);
if (sourcePreorder && destinationPreorder) {
  destinationPreorder.innerHTML = sourcePreorder.innerHTML;
  destinationPreorder.classList.toggle('hidden', sourcePreorder.innerHTML.trim() === '');
}

        
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  // NEW: Method to update variant-specific content based on the "Kleur" option
updateVariantContent() {
  // Hide all variant-specific content sections by default
  document.querySelectorAll('.variant-content').forEach(el => {
    el.style.display = 'none';
  });

  // If no variant is selected, exit early
  if (!this.currentVariant) return;

  // Assuming "Kleur" is stored in option1 (adjust the index if needed)
  const kleur = this.currentVariant.option1;

  if (kleur === 'Pink Paradise') {
    const pinkSection = document.querySelector('.variant-content.pink-paradise');
    if (pinkSection) pinkSection.style.display = 'block';
  } else if (kleur === 'Amazing Anthracite') {
    const anthraciteSection = document.querySelector('.variant-content.amazing-anthracite');
    if (anthraciteSection) anthraciteSection.style.display = 'block';
  } else if (kleur === 'Blue Bliss') {
    const blueBlissSection = document.querySelector('.variant-content.blue-bliss');
    if (blueBlissSection) blueBlissSection.style.display = 'block';
  } else if (kleur === 'Champagne Dreams') {
    const champagneDreamsSection = document.querySelector('.variant-content.champagne-dreams');
    if (champagneDreamsSection) champagneDreamsSection.style.display = 'block';
  } else if (kleur === 'Tropical Taupe') {
    const taupeSection = document.querySelector('.variant-content.tropical-taupe');
    if (taupeSection) taupeSection.style.display = 'block';
  } else if (kleur === 'Universal Black') {
    const taupeSection = document.querySelector('.variant-content.universal-black');
    if (taupeSection) taupeSection.style.display = 'block';
  } else if (kleur === 'Colourful Animals') {
    const anthraciteSection = document.querySelector('.variant-content.colourful-animals');
    if (anthraciteSection) anthraciteSection.style.display = 'block';
  } else if (kleur === 'Dino') {
    const anthraciteSection = document.querySelector('.variant-content.dino');
    if (anthraciteSection) anthraciteSection.style.display = 'block';
  } else if (kleur === 'Happy Bear') {
    const anthraciteSection = document.querySelector('.variant-content.happy-bear');
    if (anthraciteSection) anthraciteSection.style.display = 'block';
  } else if (kleur === 'Jungle Fantasy') {
    const anthraciteSection = document.querySelector('.variant-content.jungle-fantasy');
    if (anthraciteSection) anthraciteSection.style.display = 'block';
  } else if (kleur === 'Lucky Lion') {
    const anthraciteSection = document.querySelector('.variant-content.lucky-lion');
    if (anthraciteSection) anthraciteSection.style.display = 'block';
  } else if (kleur === 'Party Lama') {
    const anthraciteSection = document.querySelector('.variant-content.party-lama');
    if (anthraciteSection) anthraciteSection.style.display = 'block';
  } else if (kleur === 'Princess') {
    const anthraciteSection = document.querySelector('.variant-content.princess');
    if (anthraciteSection) anthraciteSection.style.display = 'block';
  } else if (kleur === 'Rainbow Unicorn') {
    const anthraciteSection = document.querySelector('.variant-content.rainbow-unicorn');
    if (anthraciteSection) anthraciteSection.style.display = 'block';
  } else if (kleur === 'Silver Stars') {
    const anthraciteSection = document.querySelector('.variant-content.silver-stars');
    if (anthraciteSection) anthraciteSection.style.display = 'block';
  } else if (kleur === 'Smiling Dragon') {
    const anthraciteSection = document.querySelector('.variant-content.smiling-dragon');
    if (anthraciteSection) anthraciteSection.style.display = 'block';
  } else if (kleur === 'Soccer Dream') {
    const anthraciteSection = document.querySelector('.variant-content.soccer-dream');
    if (anthraciteSection) anthraciteSection.style.display = 'block';
  } else if (kleur === 'Space Dream') {
    const anthraciteSection = document.querySelector('.variant-content.space-dream');
    if (anthraciteSection) anthraciteSection.style.display = 'block';
  } else {
    const defaultSection = document.querySelector('.variant-content.default');
    if (defaultSection) defaultSection.style.display = 'block';
  }

  // ------------------------------------------
  // Now update the input containers:
  // All your input containers have a class matching the variant color (in lowercase and hyphenated)
  // For example, "Amazing Anthracite" becomes "amazing-anthracite"
  // ------------------------------------------
  const selectedColorClass = kleur.toLowerCase().replace(/\s+/g, '-');

  // Loop through all input containers
  document.querySelectorAll('.inputs').forEach(container => {
    // If this container's class list includes the selected color class,
    // remove the disabled attribute from all inputs inside it.
    if (container.classList.contains(selectedColorClass)) {
      container.querySelectorAll('input').forEach(input => {
        input.disabled = false;
      });
    } else {
      // Otherwise, disable all input fields in this container.
      container.querySelectorAll('input').forEach(input => {
        input.disabled = true;
      });
    }
  });
}
}

customElements.define('variant-selects', VariantSelects);




class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class AnnouncementBar extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const id = this.dataset.selector;
    const config = {
      dots: false,
      loop: false,
      arrows: false,
      autoplay: true,
      spaceBetween: 10,
      breakpoints: {
        320: {
          slidesPerView: 1,
          slidesPerGroup: 1,
        },
        768: {
          slidesPerView: 2,
          slidesPerGroup: 1,
        },
        1200: {
          slidesPerView: 3,
          slidesPerGroup: 3,
        }
      }
    };

    new Swiper("#swiper-" + id, config);
  }
}
customElements.define("announcement-bar", AnnouncementBar);

class ChildMenu extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.querySelector('[data-childmenu-toggle]')?.addEventListener( 'click', function(e){
      e.preventDefault();
      if (!this.classList.contains('active')) {
        [...document.querySelectorAll('[data-childmenu-toggle]')].map(x=>x.classList.remove('active'));
      }
      this.classList.toggle('active');
    });
  }
}
customElements.define("child-menu", ChildMenu );

class ProductCarousels extends HTMLElement {
  constructor(){
    super();

    this.productCarouselSwitcher();
  }

  productCarouselSwitcher(){
    let selector = this.querySelector('[data-collection-switcher]');
    let collections = this.querySelectorAll('[data-product-carousel]');
    selector.querySelectorAll('[data-title-selector]').forEach( (element) => {

      element.addEventListener('click', function(){
        let collection = this.dataset.collection;
        [...collections].map( x => x.classList.add('hidden') );
        [...selector.querySelectorAll('[data-title-selector]')].map( x => x.classList.remove('active') );
        this.classList.add('active');
        document.getElementById(collection).classList.remove('hidden');
      });
    });
  }
}
customElements.define('product-carousels', ProductCarousels);

class ScrollInView extends HTMLElement {
  constructor(){
    super();
  }

  connectedCallback() {
    const scroller = this.querySelector('[data-scroller]');
    scroller.addEventListener( 'click', (e) => {
      e.preventDefault();
      let section = scroller.getAttribute('href').replace('#', '');
      let element = document.getElementById(section);
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
    });
  }
}
customElements.define('scroll-inview', ScrollInView);

class DateTime extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const now = new Date();
    var nextDay = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);

    setInterval(function () {

      const base = "0";

      // Get today's date and time
      var now = new Date().getTime();

      var timeDifference = nextDay - now;

      const hours = Math.floor(timeDifference / (1000 * 60 * 60));
      const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

      var element = document.querySelector("[data-countdown]");

      element.querySelector("[data-hour]").innerHTML    = hours < 10 ? base.concat(hours): hours;
      element.querySelector("[data-minute]").innerHTML  = minutes < 10 ? base.concat(minutes): minutes;
      element.querySelector("[data-second]").innerHTML  = seconds < 10 ? base.concat(seconds): seconds;
    }, 1000);
  }
}
customElements.define("date-time", DateTime);

class VideoPlayer extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;

    if (poster.dataset.autoplay == 'true') {
      this.loadContent();
    }

    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );

      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}
customElements.define("video-player", VideoPlayer);



(() => {
  let updating = false;
  let lastVariantId = null;

  async function refreshMachineSize(variantId) {
  const wraps = document.querySelectorAll("#MachineSizeWrap");
  if (!wraps.length || !variantId) return;
  if (updating || variantId === lastVariantId) return;

  updating = true;
  lastVariantId = variantId;

  try {
    const url = new URL(window.location.href);
    url.searchParams.set("variant", variantId);

    const res = await fetch(url.toString(), { headers: { Accept: "text/html" } });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const html = await res.text();

    const doc = new DOMParser().parseFromString(html, "text/html");
    const fresh = doc.getElementById("MachineSizeWrap");

    if (fresh) {
      wraps.forEach((wrap) => {
        wrap.innerHTML = fresh.innerHTML;
      });
      console.log(`Updated ${wraps.length} MachineSizeWrap elements`);
    }
  } catch (e) {
    console.error("MachineSize refresh failed:", e);
    lastVariantId = null;
  } finally {
    updating = false;
  }
}

  function getVariantId() {
    const input = document.querySelector(
      'form[action*="/cart/add"] input[name="id"]'
    );
    return input?.value || null;
  }

  // Poll briefly after interaction until the value actually changes
  function waitForVariantChange(prevId, attempts = 0) {
    if (attempts > 20) return; // give up after ~1s
    const current = getVariantId();
    if (current && current !== prevId) {
      refreshMachineSize(current);
    } else {
      setTimeout(() => waitForVariantChange(prevId, attempts + 1), 50);
    }
  }

  function hook() {
    // Use a MutationObserver on the hidden input as the primary trigger
    const idInput = document.querySelector(
      'form[action*="/cart/add"] input[name="id"]'
    );
    if (idInput) {
      const obs = new MutationObserver(() => {
        const vid = idInput.value;
        if (vid) refreshMachineSize(vid);
      });
      obs.observe(idInput, { attributes: true, attributeFilter: ["value"] });
    }

    // Fallback: click/change still triggers, but polls for the real update
    document.addEventListener("click", (e) => {
      if (e.target.closest(".product-form__input label")) {
        waitForVariantChange(getVariantId());
      }
    });

    document.addEventListener("change", (e) => {
      if (
        e.target.closest(".product-form__input") ||
        e.target.matches('select[name="id"]')
      ) {
        waitForVariantChange(getVariantId());
      }
    });

    document.addEventListener("variant:change", () => {
      waitForVariantChange(lastVariantId);
    });

    // Initial sync
    const vid = getVariantId();
    if (vid) refreshMachineSize(vid);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", hook);
  } else {
    hook();
  }

  document.addEventListener("shopify:section:load", () => {
    lastVariantId = null;
    setTimeout(hook, 0);
  });
})();